import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'translateStatus',
  standalone: true,
})
export class TranslateStatusPipe implements PipeTransform {
  transform(value: string | undefined): string {
    if (!value) return '';
    const translations: { [key: string]: string } = {
      APPROVED: 'Godkänd',
      PAID: 'Skickad till fortnox',
      REJECTED: 'Avvisad',
    };
    return translations[value] || value;
  }
}
